import { Form } from 'antd';
import { FormItemProps } from 'components/Form/FormItem';
import { useMeterContext } from 'contexts/Meter';
import { isNil } from 'rambda';
import { VFC } from 'react';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { Commodity } from '@enmon/commons/lib/shared';
import { ElectricityMeterDetails, MeterElectricityDetailsProps } from './Electricity';
import { ThermalMeterDetails, MeterThermalDetailsProps } from './Thermal';
import { MeterWaterDetailsProps, WaterMeterDetails } from './Water';
import { GasMeterDetails, MeterGasDetailsProps } from './Gas';
import { MeterOtherDetailsProps, OtherMeterDetails } from './Other';

export const TypeDetails: VFC = () => {
  const { enmonMeter } = useMeterContext();
  const { commodity } = enmonMeter ?? {};

  const form = Form.useFormInstance();
  const { detail, setDetailsStepValues } = useReplaceMeterStore();

  const handleDetailsFormItemReset = (namePath: FormItemProps['name']) => {
    const name = Array.isArray(namePath) ? namePath.at(-1) : namePath;

    if (isNil(namePath) || isNil(name)) return;

    form.setFieldValue(namePath, null);
    setDetailsStepValues({
      detail: {
        ...detail,
        [name]: null,
      },
    });
  };

  switch (commodity) {
    case Commodity.Electricity:
      return (
        <ElectricityMeterDetails
          {...({
            ...detail,
            onFormItemReset: handleDetailsFormItemReset,
          } as MeterElectricityDetailsProps)}
        />
      );
    case Commodity.Thermal:
      return (
        <ThermalMeterDetails
          {...({
            ...detail,
            onFormItemReset: handleDetailsFormItemReset,
          } as MeterThermalDetailsProps)}
        />
      );
    case Commodity.Water:
      return (
        <WaterMeterDetails
          {...({
            ...detail,
            onFormItemReset: handleDetailsFormItemReset,
          } as MeterWaterDetailsProps)}
        />
      );
    case Commodity.NaturalGas:
      return (
        <GasMeterDetails
          {...({
            ...detail,
            onFormItemReset: handleDetailsFormItemReset,
          } as MeterGasDetailsProps)}
        />
      );
    case Commodity.Other:
      return <OtherMeterDetails {...(detail as MeterOtherDetailsProps)} />;
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      console.error(`Third step with unknown commodity: ${commodity ?? 'undefined'}`);
      return null;
  }
};
